import {
  CheckCircleOutlined,
  DescriptionOutlined,
  Headphones,
  VideocamOutlined,
  Close as CloseIcon
} from "@mui/icons-material";
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Stack,
  useTheme,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import { useState} from "react";


export default function HelpCenter() {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const [activeCard, setActiveCard] = useState("");

  /* On click open dailog */
  const handleOpen = (type) => {
    setActiveCard(type);
    setOpenDialog(true);
  };

  /* On close icon click close dailog */
  const handleClose = () => {
    setOpenDialog(false);
    setActiveCard("");
  };

  const renderDialogContent = () => {
    switch (activeCard) {
      case "documentation":
        return <Typography variant="body1">Documentation content comming soon...</Typography>;
      case "videos":
        return <Typography variant="body1">Video tutorial content comming soon...</Typography>;
      case "onboarding":
        return <Typography variant="body1">Onboarding checklist comming soon...</Typography>;
      case "support":
        return <Typography variant="body1">Live support info comming soon...</Typography>;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%)' }}>
      {/* Content heading */}
      <Typography variant="h5" fontWeight={600}>
        How can we help you?
      </Typography>

      {/* Row 1 */}
      <Grid container sx={{ pt: 2 }} spacing={2}>
        <Grid size={{xs:12, sm:12, md:6}} >
          <Card elevation={0} 
           sx={{ borderRadius: 2, cursor: 'pointer', transition: 'transform 200ms ease, box-shadow 200ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 } }} 
           onClick={() => handleOpen("documentation")}
          >
            <CardContent>
              <Stack sx={{ flexDirection: 'column', gap: 1 }}>
                <DescriptionOutlined color="primary" sx={{ fontSize: 50 }} />
                <Typography variant="h6" fontWeight={600}>Documentation Library</Typography>
                <Typography variant="body2" sx={{ color: theme.palette.neutral.normal }}>
                  Comprehensive guides 
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{xs:12, sm:12, md:6}}>
          <Card elevation={0} 
           sx={{ borderRadius: 2, cursor: 'pointer', transition: 'transform 200ms ease, box-shadow 200ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 } }} 
           onClick={() => handleOpen("videos")}
          >
            <CardContent>
              <Stack sx={{ flexDirection: 'column', gap: 1 }}>
                <VideocamOutlined color="primary" sx={{ fontSize: 50 }} />
                <Typography variant="h6" fontWeight={600}>Video Tutorials</Typography>
                <Typography variant="body2" sx={{ color: theme.palette.neutral.normal }}>
                  Step-by-Step video walkthroughs
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Row 2 */}
      <Grid container sx={{ pt: 2 }} spacing={2}>
        <Grid size={{xs:12, sm:12, md:6}}>
          <Card elevation={0} 
           sx={{ borderRadius: 2, cursor: 'pointer', transition: 'transform 200ms ease, box-shadow 200ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 } }} 
           onClick={() => handleOpen("onboarding")}
          >
            <CardContent>
              <Stack sx={{ flexDirection: 'column', gap: 1 }}>
                <CheckCircleOutlined color="primary" sx={{ fontSize: 50 }} />
                <Typography variant="h6" fontWeight={600}>Onboarding Checklist</Typography>
                <Typography variant="body2" sx={{ color: theme.palette.neutral.normal }}>
                  Get started with setup and launch
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{xs:12, sm:12, md:6}}>
          <Card elevation={0}
            sx={{ borderRadius: 2, cursor: 'pointer', transition: 'transform 200ms ease, box-shadow 200ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 } }}
            onClick={() => handleOpen("support")}>
            <CardContent>
              <Stack sx={{ flexDirection: 'column', gap: 1 }}>
                <Headphones color="primary" sx={{ fontSize: 50 }} />
                <Typography variant="h6" fontWeight={600}>Live Support</Typography>
                <Typography variant="body2" sx={{ color: theme.palette.neutral.normal }}>
                  Chat with our support team
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Full-Screen Dialog */}
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
       
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
              {activeCard === "documentation" && "Documentation Library"}
              {activeCard === "videos" && "Video Tutorials"}
              {activeCard === "onboarding" && "Onboarding Checklist"}
              {activeCard === "support" && "Live Support"}
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: 3 }}>
          {renderDialogContent()}
        </Box>
      </Dialog>
    </Box>
  );
}
